import * as dbPath from 'common/api/db/paths';
import { DbRefs } from 'common/db/api/types';
import {
	buildQuery,
	createBasicCollectionOperations,
	createBasicDbOperations,
	createBasicDocOperations,
} from '../utils';
import { StockItemApi, StockItemHistory, StockVariantApi } from 'common/types';

export const getStockItemQueries = (dbRefs: DbRefs) => {
	const collectionPath = dbPath.stockItems;
	// const dataUpdater = updateToNewOrderProductType;
	const dataUpdater = undefined;
	const query = buildQuery<StockItemApi | StockVariantApi>(collectionPath, dbRefs, dataUpdater);
	return {
		...createBasicCollectionOperations<StockItemApi>(collectionPath, dbRefs, dataUpdater),
		doc: (id: string) => ({
			...createBasicDocOperations<StockItemApi>(collectionPath, dbRefs, id, dataUpdater),
			itemHistory: itemHistoryQueries(dbRefs, id),
		}),
		items: buildQuery<StockItemApi>(collectionPath, dbRefs, dataUpdater).where(
			'type',
			'==',
			'item',
		),
		variants: buildQuery<StockVariantApi>(collectionPath, dbRefs, dataUpdater).where(
			'type',
			'==',
			'variant',
		),
		getByType: (type: StockItemApi['type'] | StockVariantApi['type']) =>
			query.where('type', '==', type),
	};
};

const itemHistoryQueries = (dbRefs: DbRefs, shopId: string) => {
	const collectionPath = `${dbPath.stockItemDoc(shopId)}/itemHistory`;
	return createBasicDbOperations<StockItemHistory>(collectionPath, dbRefs);
};
